export const PAIEMENT_ENREGISTRER = 'paiement/PAIEMENT_ENREGISTRER';
export const PAIEMENT_LISTER = 'paiement/PAIEMENT_LISTER';
